import { useFormikContext } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import AddressOptions from './AddressOptions';
import AddressForm from './AddressForm';
import _ from 'lodash';
import { storeAssigned } from '@/services/Methods/normalMethods';

function CheckoutStepThree(props) {
    const {
        countryState, _handelGooglePlace, setCountryState, handleChangeFunction, normalAddressError, error, setUserDetails,
        _setUseDefaultAddressFunction, sameAsBillingChecked, _paymentOptionSetBilling, userData, formData, setFormData, isUserLogin,
        countryCodes, dispatch, loginSliceloading
    } = props;

    const [showAddressOption, setShowAddressOption] = useState(false);

    const fieldValue = useFormikContext();
    useEffect(() => {
        if (userData?.emailAddress) {
            const PICK_ADDRESSES = _.pick(userData, ['shippingAddress', 'otherAddress1', 'otherAddress2']);
            const ADDRESSES = _.compact(_.map(_.values(PICK_ADDRESSES), (val, index) => {
                const SECTION = _.keys(PICK_ADDRESSES);
                if (SECTION[index] !== "shippingAddress") {
                    const { address1, city, postalCode } = PICK_ADDRESSES?.shippingAddress;
                    if (val?.address1 !== address1) {
                        return ({
                            id: index + 1,
                            firstName: userData?.firstName,
                            lastName: userData?.lastName,
                            section: SECTION[index], ...val
                        });
                    }
                } else {
                    return ({
                        id: index + 1,
                        firstName: userData?.firstName,
                        lastName: userData?.lastName,
                        section: SECTION[index], ...val
                    });
                }
            }))
            if (_.filter(ADDRESSES, (r) => (r?.countryCode === _.upperCase(storeAssigned()) && r?.address1))?.length > 0) {
                setShowAddressOption(true)
            } else {
                setShowAddressOption(false)
            }
        }
    }, [userData?.emailAddress])

    return (
        <>
            {(isUserLogin && userData?.emailAddress && showAddressOption)
                ?
                <div className='mb-2 field-class'>
                    <AddressOptions
                        {...{
                            isUserLogin,
                            checkoutError: error,
                            setDefaultValues: setUserDetails,
                            _setUseDefaultAddressFunction,
                            sameAsBillingChecked,
                            _paymentOptionSetBilling,
                            allUserData: userData,
                            handleChangeFunction,
                            userFormData: formData,
                            setUserFormData: setFormData,
                            countryCodes, normalAddressError,
                            countryState, setCountryState,
                            _handelGooglePlace, dispatch,
                            isLoading: loginSliceloading
                        }} />
                    <div className='text-[16px] text-red-500 font-semibold'>{normalAddressError}</div>
                </div>
                :
                <AddressForm {...{
                    _handelGooglePlace,
                    isUserLogin,
                    fieldValue,
                    dispatch,
                    handleChangeFunction,
                    normalAddressError,
                    countryState,
                    setCountryState,
                    checkoutError: error,

                }} />
            }
        </>

    )
}

export default CheckoutStepThree;